<template>
  <div>
    <text-overlay :show="querying_api" :text="overlay_text" no-wrap fixed/>
    <!-- Tribal form -->
    <div id="tribal-renter-forms">
      <div v-if="needsTribalForm">
        <h5>Are you a Southern Ute Tribal Member, member of another Native American Tribe, or a person of Native American descent?</h5>
        <div>*Installation costs waived for Self-identifying Tribal Members.</div><br/>
        <label class="radio-head" id="tribal-member-check">
        <input type="radio" name="tribal-status" :value="true" v-model="form_data.is_tribal">
          <span>Yes</span>
        </label>
        <label class="radio-head" id="not-tribal-member-check">
        <input type="radio" name="tribal-status" :value="false" v-model="form_data.is_tribal">
          <span>No</span>
        </label>
      </div>
      <!-- Renter form -->
      <div v-if="needsRenterForm">
        <br v-if="needsTribalForm"/>
        <div>
          <h5>Do you own or rent your home?</h5>
          <label class="radio-head" id="owner-check">
          <input type="radio" name="rent-type" :value="true" v-model="form_data.is_owner">
            <span>Own</span>
          </label>
          <label class="radio-head" id="renter-check">
          <input type="radio" name="rent-type" :value="false" v-model="form_data.is_owner">
            <span>Rent</span>
          </label>
        </div>
      </div>
      <Transition v-on:enter="scrolldown('tribal-renter-forms')">
        <div v-if="isRenter && needsRenterForm && rentersAllowed"><br/>
          <span>Renters must gain approval from the homeowner. Please enter the owner's contact information.</span>
          <div class="row">
            <xm-input class="col-md-5" v-model="form_data.owner_name" name="name" label="Owner name" :pattern="regex.name" required error="Enter owner name"></xm-input>
            <xm-input class="col-md-3" v-model="form_data.owner_phone" name="phone" label="Owner phone" :pattern="regex.phone" v-mask="'(###) ###-####'" required error="Please enter a valid phone number"></xm-input>
            <xm-input class="col-md-4" v-model="form_data.owner_email" name="email" label="Owner email" type="email" :pattern="regex.email" required error="Please enter a valid email address"></xm-input>
          </div>
        </div>
      </Transition>
      <Transition v-on:enter="scrolldown('tribal-renter-forms')">
        <div v-if="isRenter && needsRenterForm && !rentersAllowed">
          <br/>
          <h5>Owner approval form</h5>
          <span>Renters must gain approval from the homeowner. Please download and ask your landlord to complete the approval form. Once completed, please contact XMission sales to complete the signup process.</span><br/><br/>
          <b-button variant="primary" class="submit-button" href="https://asset.xmission.com/pdf/lehi-fiber-rental-agreement.pdf" target="_blank" download="lehi-fiber-rental-agreement.pdf">
            Download rental approval form
          </b-button>
          <br/><br/>
          <h5>Your contact information</h5>
          <span>If you would like sales to reach out to you please provide your contact information.</span>
          <div class="row">
            <xm-input class="col-md-5" v-model="form_data.owner_name" name="name" label="Full Name" :pattern="regex.name" required error="Enter your name"></xm-input>
            <xm-input class="col-md-3" v-model="form_data.owner_phone" name="phone" label="Phone Number" :pattern="regex.phone" v-mask="'(###) ###-####'" required error="Please enter a valid phone number"></xm-input>
            <xm-input class="col-md-4" v-model="form_data.owner_email" name="email" label="Email Address" type="email" :pattern="regex.email" required error="Please enter a valid email address"></xm-input>
          </div>
          <div>
            <b-button :disabled="!validOwnerContact" variant="primary" class="submit-button" @click="addRenterContact()">Submit</b-button>
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>


<script>
  import TextOverlay from '../../TextOverlay';
  import { BButton } from 'bootstrap-vue';
  import ConnectivityService from '../../../lib/ssu/input_models/connectivity-service';
  import reg from '../../../lib/regex.js';
  import req from '../../../lib/authRequest';
  import helpers from '../../../lib/helpers.js';
  import XmInput from '../../XmInput.vue';
  import logger from "../../../lib/logger";

  export default {
    data () {
      return {
        regex: reg,
        scrolldown: helpers.scrolldown,
        querying_api: false,
        overlay_text: '',
        form_data: {
          is_owner: null,
          is_tribal: null,
          owner_phone: '',
          owner_email: '',
          owner_name: ''
        }
      }
    },

    emits: ['form-state', 'form-valid', 'form-invalid', 'input'],
    props: {
      service: {
        required: true,
        type: ConnectivityService
      },
    },

    mounted() {
      // emit first thing since there may be nothing to do
      logger.debug('customer details mounted');
      this.$emit('form-state', this.formValid);
      this.$emit('input', this.formData);
    },

    computed: {
      rentersAllowed() {
        return this.service.service.renters_allowed;
      },
      needsRenterForm() {
        logger.debug('owner data required', this.service.service.owner_data_required);
        return this.service.service.owner_data_required;
      },
      needsTribalForm() {
        return this.service.service.tribal_data_required;
      },
      isOwner () {
        return this.form_data.is_owner === true;
      },
      isRenter () {
        return this.form_data.is_owner === false;
      },
      validOwnerName() {
        return !!this.form_data.owner_name.match(this.regex.name);
      },
      validOwnerEmail() {
        return !!this.form_data.owner_email.match(this.regex.email);
      },
      validOwnerPhone() {
        return !!this.form_data.owner_phone.match(this.regex.phone);
      },
      validOwnerContact() {
        return this.validOwnerName && this.validOwnerEmail && this.validOwnerPhone;
      },
      renterFormValid() {
        if (this.needsRenterForm) {
          if (this.form_data.is_owner === null) {
            return false;
          }
          if (!this.rentersAllowed){
            return this.isOwner;
          }
          if (this.isRenter) {
            return this.validOwnerContact;
          }
        }
        return true;
      },
      tribalFormValid() {
        if (this.needsTribalForm) {
          return this.form_data.is_tribal !== null;
        }
        return true;
      },
      signupAllowed() {
        if (!this.rentersAllowed) {
          return this.isOwner;
        }
        return true;
      },
      formValid() {
        logger.debug('customer details formValid', this.renterFormValid, this.tribalFormValid, this.signupAllowed)
        return this.renterFormValid && this.tribalFormValid && this.signupAllowed;
      },
      formData() {
        return this.form_data;
      }
    },

    methods: {
      addRenterContact() {
        this.querying_api = true;
        let self = this;
        this.overlay_text = "Saving contact information...";
        let data = {address_id: this.service.address_details.address_id,
                    email: this.form_data.owner_email,
                    phone: this.form_data.owner_phone,
                    name: this.form_data.owner_name,
                    provider_id: this.service.provider.provider_id};
        req.post({
          url: '/connectivity_clots/renter',
          data: data,
          success(res){
            self.$emit('contact-added');
            self.querying_api = false;
          },
          error(){
            self.querying_api = false;
          }
        })
      },
    },

    watch: {
      formValid(new_val, old_val) {
        this.$emit('form-state', new_val);
        this.$emit(new_val ? 'form-valid' : 'form-invalid');
      },
      formData: {
        handler(new_val, old_val) {
          if (new_val.is_tribal === null) {
            new_val.is_tribal = false;
          }
          this.$emit('input', new_val);
        },
        deep: true
      }
    },

    components: {
      TextOverlay,
      BButton,
      XmInput
    }


  }
</script>

<style scoped>
  .liteMode a {
    color: white;
  }

  .submit-button {
    color: white !important;
  }
</style>



// WEBPACK FOOTER //
// CustomerDetails.vue?1cfd0d54